import MatestackUiVueJs from "matestack-ui-vuejs";

// Sidecar for Web::Components::AskAnswer. Keeps the answer from the form's
// success event as plain data; a failed or new request clears the old answer.
const askAnswer = {
  mixins: [MatestackUiVueJs.componentMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,
  inject: ["appNavigateTo"],
  data() {
    return { answer: null };
  },
  created() {
    this.onAnswer = (data) => (this.answer = (data && data.answer) || null);
    this.onReset = () => (this.answer = null);
    this.names(this.props["events"]).forEach((n) => MatestackUiVueJs.eventHub.$on(n, this.onAnswer));
    this.names(this.props["reset_events"]).forEach((n) => MatestackUiVueJs.eventHub.$on(n, this.onReset));
  },
  beforeUnmount() {
    this.names(this.props["events"]).forEach((n) => MatestackUiVueJs.eventHub.$off(n, this.onAnswer));
    this.names(this.props["reset_events"]).forEach((n) => MatestackUiVueJs.eventHub.$off(n, this.onReset));
  },
  methods: {
    // Answer links are site paths: follow them as a Matestack transition so
    // only the page swaps. Anything else (should never happen) loads normally.
    go(href) {
      if (typeof href === "string" && href.startsWith("/") && !href.startsWith("//")) {
        this.appNavigateTo({ url: href, backwards: false });
      } else if (href) {
        window.location.href = href;
      }
    },
    names(list) {
      return String(list || "").split(",").map((n) => n.trim()).filter(Boolean);
    },
  },
};

export default askAnswer;
